"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _color = _interopRequireDefault(require("color"));

var setPrimaryColor = function setPrimaryColor(color) {
  document.documentElement.style.setProperty('--theme-primary', color);
  document.documentElement.style.setProperty('--theme-primary-dark', (0, _color.default)(color).darken(0.05).string());
  document.documentElement.style.setProperty('--theme-primary-lighter', (0, _color.default)(color).lightness(95).string());
  document.documentElement.style.setProperty('--button-primary-shadow-color', (0, _color.default)(color).alpha(0.3).string());
};

var _default = setPrimaryColor;
exports.default = _default;